import DownArrowIcon from './DownArrowIcon'

export default DownArrowIcon
